import { MoreMenu } from 'components/shared/DragAndDropWorkspace/MoreMenu';
import { memo } from 'react';
import { WorkspaceType } from 'state/workspaces/model';
import { WorkspaceTab } from 'state/workspaces/tabs/tabs.model';

import { IconButton } from './Tab/IconButton';

type Props = Readonly<{
  showAddButton: boolean;

  hasSelectedTab: boolean;

  onTabCreated: () => void;

  onReset: () => void;

  onImportExcel?: () => void;
  tabs: WorkspaceTab[];
  setSelectedTab: (tab: WorkspaceTab) => void;
  workspace: WorkspaceType;
  addTabTooltip?: string;
}>;

function RightMenuComponent({
  showAddButton,
  hasSelectedTab,
  onTabCreated,
  onReset,
  onImportExcel,
  tabs,
  setSelectedTab,
  workspace,
  addTabTooltip,
}: Props) {
  return (
    <div className="flex-shrink-0 border-bottom d-flex justify-content-end align-items-start">
      {showAddButton && (
        <IconButton
          icon="add"
          active={!hasSelectedTab}
          onClick={onTabCreated}
          e2e="add-new-tab"
          btnClassName="btn-flat-secondary border-start"
          tooltip={addTabTooltip}
        />
      )}
      <MoreMenu
        tabs={tabs}
        addNewTab={onTabCreated}
        importExcel={onImportExcel}
        clearAll={onReset}
        onTabActivated={setSelectedTab}
        workspaceType={workspace}
      />
    </div>
  );
}

export const RightMenu = memo(RightMenuComponent);
